import type { Action } from 'redux';
import type { TargetEventRecommendation } from '../../../../../../shared/types/skadNetwork.types';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const GetTargetEventsRecommendations = new ReduxAsyncAction<
  'GET_TARGET_EVENTS_RECOMMENDATIONS',
  void,
  TargetEventRecommendation[]
>('GET_TARGET_EVENTS_RECOMMENDATIONS');

GetTargetEventsRecommendations.registerRequest(async () => {
  try {
    const response = await dash_api.get<TargetEventRecommendation[]>('/v1/skadnetworkv2/recommendations/target-events');

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get target events recommendations. Please try again.', 'error');

    throw error;
  }
});

export const GET_TARGET_EVENTS_RECOMMENDATIONS = GetTargetEventsRecommendations.actionNamespaceConstants;

export const getTargetEventsRecommendations = GetTargetEventsRecommendations.request;

export type GetTargetEventsRecommendationsRequestAction = Action<typeof GET_TARGET_EVENTS_RECOMMENDATIONS.request>;

export type GetTargetEventsRecommendationsResponseAction = Action<typeof GET_TARGET_EVENTS_RECOMMENDATIONS.response> & {
  data: TargetEventRecommendation[];
};
